<template>
  <!--row是否隐藏-->
  <div class="jz_mobi_designer_btn_list" :class="$store.state.mb_row_isShow.eye_btn_isShow ? '' : 'jz_eye_btn_hidden'">
    <button class="jz_mobi_btn_showAllRow" :class="$store.state.mb_row_isShow.row_btn_isShow ? 'show' : ''" @click="row_btn_change"></button>
  </div>

</template>

<script>
import i18n from '../../language/index'

    export default {
      name: "mb_row_isShow",
      methods:{
        row_btn_change(){
          const r = this.$store.state.mb_row_isShow.row_btn_isShow;
          this.$store.commit('mb_row_isShow/SET_isShow',!r);
        }
      },

      mounted(){
        this.templet.mb_eye_isShow();

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/mb_row_isShow/index.vue